import type { ReactNode } from "react";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}